export const footerInfo = [
  { link: "https://www.linkedin.com/in/dakotafabro/", icon: "fab fa-linkedin" },
  { link: "https://github.com/dakotafabro", icon: "fab fa-github" },
  //   { link: "https://www.instagram.com/kodingkoda/", icon: "fab fa-instagram" },
];
